export const FIELD_TYPE_OPTIONS = ['text', 'date', 'select', 'country', 'checkbox', 'radio'];
export const OPTION_FIELD_TYPES = new Set(['select', 'radio']);

export function normalizeFields(value) {
  if (Array.isArray(value)) {
    return value;
  }

  if (value && typeof value === 'object') {
    return Object.values(value);
  }

  return [];
}

export function normalizeSteps(payload) {
  const candidates = [
    payload?.steps,
    payload?.step,
    payload?.kyc?.steps,
    payload?.kyc,
    payload?.settings?.steps,
    payload?.settings?.kyc?.steps,
    payload?.jurisdiction?.steps,
    payload?.data?.steps,
    payload?.items,
    payload,
  ];

  for (const candidate of candidates) {
    if (Array.isArray(candidate)) {
      return candidate;
    }

    if (candidate && typeof candidate === 'object') {
      const values = Object.values(candidate);
      if (values.length > 0 && values.some((item) => item && typeof item === 'object' && ('name' in item || 'description' in item))) {
        return values;
      }
    }
  }

  return [];
}

export function toRow(step, index) {
  const fields = normalizeFields(step?.fields);
  const order = Number.isFinite(step?.position)
    ? step.position
    : (Number.isFinite(step?.order) ? step.order : index);
  const stepId = String(step?.id || step?.uid || '').trim();

  return {
    id: stepId || `kyc-step-${index}-${Math.random().toString(36).slice(2, 8)}`,
    name: step?.name || '',
    description: step?.description || '',
    immutable: Boolean(step?.immutable),
    fields,
    order,
  };
}

export function toApiStep(step, index) {
  return {
    id: step.id && !String(step.id).startsWith('kyc-step-') ? step.id : undefined,
    name: String(step.name || '').trim(),
    description: String(step.description || '').trim(),
    fields: normalizeFields(step.fields),
    order: index,
  };
}

export function prettyJson(value) {
  return JSON.stringify(value ?? [], null, 2);
}
